import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
  initialState as requestInitialState,
} from '../../utils/redux';
import { consts as authAzureConsts } from './authAzure';

export const consts = createReqConsts('auth', 'azure-login');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'azure_authentication',
  type: 'post',
  slug: ['sessions'],
});

const requestReducer = createReqReducer(consts);

const initialState = {
  ...requestInitialState,
  loginMFA: '',
  token: '',
  successAuthForSignUpFlow: false,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case authAzureConsts.SET_CREDENTIAL_FOR_MFA:
      return {
        ...state,
        loginMFA: payload.login,
        token: payload.token,
      };
    case authAzureConsts.SET_SUCCESS_SIGN_UP_FLOW:
      return {
        ...state,
        successAuthForSignUpFlow: true,
      };
    case consts.REJECTED:
      return {
        ...initialState,
        ...payload,
        rejected: true,
        loginMFA: state.loginMFA,
        token: state.token,
      };
    case consts.CLEAR:
      return {
        ...initialState,
      };
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/auth/login-azure.js